import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * Yarntons — simple store-availability list.
 *
 * The list itself is server-rendered by snippets/pickup-availability-list.liquid.
 * This component only keeps it fresh: when the customer picks a different
 * size or style, the variant picker fetches the re-rendered section and
 * resolves a ProductSelectEvent promise with that HTML — we lift our new
 * markup out of it and morph it in. No extra network requests.
 *
 * Mirrors the listener pattern used by assets/product-inventory.js.
 */
class LocalPickup extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * Handles product select event by refreshing the availability list.
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productUrl = newProduct.url;
        }

        const newPickup = html.querySelector('local-pickup');
        if (!newPickup) return;

        if (newPickup.hasAttribute('hidden')) {
          this.setAttribute('hidden', '');
        } else {
          this.removeAttribute('hidden');
        }

        if (newPickup.dataset.variantId) {
          this.dataset.variantId = newPickup.dataset.variantId;
        }

        morph(this, newPickup, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[local-pickup] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('local-pickup')) {
  customElements.define('local-pickup', LocalPickup);
}
